<template>
  <div
    class="overlay"
    :class="{ 'inner-modal': innerModal }"
    @mousedown="onMouseDown"
    @mouseup="onMouseUp"
    @drop.prevent
  >
    <div class="modal" :style="{ width: width + 'px' }">
      <div v-if="showHeader" class="top">
        <h2 class="leading-[1.1]">{{ title }}</h2>
        <div v-if="closeButton" class="close" @click="onCloseModal">
          <svg-icon :width="'14'" :height="'14'" icon="app-icons/close" />
        </div>
      </div>
      <div class="content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SvgIcon from '../all/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    width: {
      type: Number,
      required: false,
      default: 560,
    },
    closeButton: {
      type: Boolean,
      default: true,
    },
    innerModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      mousedownOnModal: false,
    };
  },

  created() {
    console.log('BaseModal created');
    // Listen for document wide key events
    window.addEventListener('keydown', this.onKeyDown);
  },

  unmounted() {
    window.removeEventListener('keydown', this.onKeyDown);
  },

  methods: {
    /**
     * Event handler: User clicks on the close button or on the overlay
     */
    onCloseModal() {
      this.$emit('closeModal');
    },

    onKeyDown(event) {
      const { key } = event;
      switch (key) {
        case 'Escape':
          this.onCloseModal();
          break;
        default:
          break;
      }
    },

    // Returns whether the focus is in input, content area or textarea
    isInputFocus() {
      return (
        $('input:focus').length > 0 ||
        $("div[contenteditable='true']:focus").length > 0 ||
        $('textarea:focus').length > 0
      );
    },

    /**
     * Event handler for mousedown on overlay
     * @param {MouseEvent} event
     */
    onMouseDown(event) {
      if (!event.target.classList.contains('overlay')) {
        this.mousedownOnModal = true;
      }
    },

    /**
     * Event handler for mouseup on overlay (and children)
     * @param {*} event
     */
    onMouseUp(event) {
      if (event.target.classList.contains('overlay')) {
        console.log(this.mousedownOnModal);
        console.log(event);
        if (
          event.offsetX < event.target.clientWidth &&
          !this.mousedownOnModal
        ) {
          this.onCloseModal();
        }
      }
      this.mousedownOnModal = false;
    },
  },
};
</script>
<style scoped lang="scss">
.overlay {
  position: fixed;
  overflow: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 50;
  background: rgba(0, 0, 0, 0.5);
}

.overlay.inner-modal {
  position: absolute;
}

.tableWrapper {
  padding: 0 40px;
}

.modal {
  max-width: calc(100% - 40px);
  background: #2c3233;
  color: #bcbcbc;
  margin: 80px auto;
  border-radius: 10px;

  .top {
    background: #303d40;
    padding: 20px;
    position: relative;
    display: flex;
    align-items: center;
    border-radius: 10px 10px 0 0;

    h2 {
      font-weight: 400;
      font-size: 18px;
      text-align: left;
      color: #bcbcbc;
      margin: 0;
      padding: 0;
      flex: 1;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .close {
      cursor: pointer;
    }
  }

  a {
    color: #db841e;
    text-decoration: none;
  }
  .icon {
    display: block;
    text-align: center;
    margin: 40px auto 30px auto;
  }
  p {
    font-size: 14px;
    line-height: 1.5;
  }
  .button {
    padding: 10px 18px;
    border-radius: 3px;
    width: 100%;
    border: none;
    color: #fff;
    background: #bf751d;
    cursor: pointer;
    margin: 25px 0 0 0;
    display: inline-block;
    width: auto;
    text-align: center;

    &:hover {
      background: #db841e;
    }

    &.full {
      display: block;
    }
  }
}
</style>
